<template>
  <!-- eslint-disable-next-line vuejs-accessibility/no-static-element-interactions -- traps focus inside unclosable alert dialog -->
  <div
    class="fixed inset-0 z-[9999] flex items-center justify-center bg-black/65 backdrop-blur-md"
    role="alertdialog"
    aria-modal="true"
    :aria-label="$t('Event moved')"
    @keydown.tab.prevent="focusCta"
  >
    <div
      class="flex w-[calc(100%-2rem)] max-w-[420px] flex-col items-center gap-4 rounded-lg bg-white p-8 text-center shadow-xl"
    >
      <h2 class="m-0 text-xl font-semibold">{{ $t('This event has been moved') }}</h2>
      <p class="m-0 text-sm text-slate-500">
        {{ $t('Please click the button below to join the event.') }}
      </p>
      <button
        ref="ctaBtn"
        class="mt-2 rounded-md border-0 px-6 py-2.5 text-sm font-semibold text-white transition-opacity disabled:cursor-not-allowed disabled:opacity-70"
        :class="{ 'hover:opacity-90': !joining }"
        :style="{ background: 'var(--theme-secondary-color, #000)' }"
        :disabled="joining"
        @click="joinEvent"
      >
        {{ joining ? $t('Redirecting...') : $t('Click here to join the event') }}
      </button>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, nextTick } from 'vue';

import logger from '@/services/logger.service';
import { safeSignout } from '@/utils/safeSignout';

const props = defineProps<{ failoverUrl: string }>();

const joining = ref(false);
const ctaBtn = ref<HTMLElement | null>(null);

function focusCta() {
  ctaBtn.value?.focus();
}

nextTick(() => ctaBtn.value?.focus());

async function joinEvent() {
  joining.value = true;
  logger.info('[FailoverUrl] User clicked join — redirecting to failover URL');
  await safeSignout().catch(() => {
    logger.error('Failed to sign out safely. Sending user to failover URL anyway.');
  });
  window.location.href = props.failoverUrl;
}
</script>
